/* Checkout previews are display metadata. Original artwork properties remain the fulfillment source. */
(function () {
  'use strict';
  if (window.PaintlyCheckoutArtwork) return;
  var ENDPOINT = 'https://paintly-checkout-artwork.paintlykits.workers.dev/preview';
  var IMAGE = '_PK Checkout Image', SOURCE = '_PK Checkout Source', ATTR = '__pk_checkout_previews';
  var CDN = 'https://cdn.shopify.com/s/files/1/0922/0974/2113/files/pk-checkout-';
  var raw = window.fetch.bind(window), ready = Object.create(null), pending = Object.create(null);
  var failed = Object.create(null), lastTable = '', cartWork = null, rerun = false, timer, release = null, checkoutBusy = false;
  var mutations = 0, revision = 0, orderWork = null;
  var retryAt = Object.create(null), retryTimer = null, retryOnVisible = false, orderChanged = false;
  var handles = ['custom-ai-paint-by-numbers-kit','custom-ai-pet-portrait-paint-by-numbers-kit','custom-ai-portrait-paint-by-numbers-kit','custom-ai-diamond-painting-kit','custom-ai-pet-portrait-diamond-painting-kit','custom-ai-portrait-diamond-painting-kit','custom-paint-by-numbers','pet-custom-paint-by-numbers','80-color-custom-paint-by-numbers','custom-diamond-painting'];
  // Exact pilot products; hidden test copies are not an unrestricted prefix.
  // Match the service's title-derived design key, not a finite pilot-handle list.
  var CRAFT_SUFFIX = /\s*\((?:\d+\s+Colou?r\s+)?(?:Paint by Numbers|Diamond Painting|Board Canvas)\)\s*$/i;
  var productTitles = Object.create(null), productTitlePending = Object.create(null), productTitleFailed = Object.create(null);
  function shapeDesign(title, handle) {
    if (typeof title !== 'string' || !CRAFT_SUFFIX.test(title) || !handle || /^custom-/.test(handle)) return '';
    var key = title.replace(CRAFT_SUFFIX, '').normalize('NFKC').replace(/[‘’]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
    return key.normalize('NFKD').replace(/[^\x00-\x7f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80) || 'design';
  }
  function formProductTitle(handle) {
    if (productTitles[handle]) return Promise.resolve(productTitles[handle]);
    if (productTitlePending[handle]) return productTitlePending[handle];
    if (productTitleFailed[handle] > Date.now() - 15000) return Promise.resolve('');
    productTitlePending[handle] = boundedFetch(root+'products/'+encodeURIComponent(handle)+'.js', {credentials:'same-origin',headers:{Accept:'application/json'}},3500)
      .then(function(r){if(!r.ok)throw new Error('product');return r.json();})
      .then(function(p){if(p.handle!==handle || typeof p.title!=='string')throw new Error('product');productTitles[handle]=p.title;return p.title;})
      .catch(function(){productTitleFailed[handle]=Date.now();return '';})
      .finally(function(){delete productTitlePending[handle];});
    return productTitlePending[handle];
  }
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';

  function shapeSource(s) {
    if (typeof s !== 'string' || s.length > 600 || /\s/.test(s)) return null;
    var m = /^https:\/\/paintly-shape-generator\.paintlykits\.workers\.dev\/images\/shapes\/([a-z0-9]+(?:-[a-z0-9]+)*)\/(wide|square)\/[a-f0-9]{32}\.jpg$/.exec(s);
    return m && m[1].length <= 80 ? m : null;
  }
  function validSource(s) {
    return !!shapeSource(s) || typeof s === 'string' && /^https:\/\/paintly-(?:image|ai)-generator\.paintlykits\.workers\.dev\/images\/(?:generations|uploads)\/\d{4}\/\d{2}\/\d{2}\/[A-Za-z0-9_-]+\.(?:jpg|jpeg|png|webp)$/.test(s);
  }
  function validImage(s) { return typeof s === 'string' && s.indexOf(CDN) === 0 && s.length < 400 && !/[^A-Za-z0-9\-._/:?=&]/.test(s); }
  function wait(ms) { return new Promise(function(resolve) { setTimeout(resolve, ms); }); }
  function boundedFetch(url, options, ms) {
    var controller = new AbortController(), t = setTimeout(function(){controller.abort();}, ms);
    options = Object.assign({}, options, {signal:controller.signal});
    return raw(url, options).finally(function(){clearTimeout(t);});
  }
  function armRetry() {
    clearTimeout(retryTimer);
    var times=Object.keys(retryAt).map(function(s){return retryAt[s];});
    if(!times.length)return;
    retryTimer=setTimeout(function(){
      if(document.hidden){retryOnVisible=true;return;}
      var now=Date.now();
      Object.keys(retryAt).forEach(function(s){if(retryAt[s]<=now)delete retryAt[s];});
      // Re-read current forms/cart. Never add a removed kit back or reuse an old
      // snapshot's quantities/properties just because its preview became ready.
      scanForms();prepareCart();armRetry();
    },Math.max(100,Math.min.apply(Math,times)-Date.now()));
  }
  function queueRetry(source, delay) {
    retryAt[source]=Date.now()+Math.max(1000,Math.min(60000,delay));
    armRetry();
  }
  function prepare(source) {
    if (!validSource(source)) return Promise.resolve(null);
    if (ready[source]) return Promise.resolve(ready[source]);
    if (pending[source]) return pending[source];
    if (retryAt[source] > Date.now()) return Promise.resolve(null);
    if (failed[source] > Date.now() - 15000) return Promise.resolve(null);
    function attempt() {
      return boundedFetch(ENDPOINT, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({source:source}), credentials:'omit'}, 6500)
        .then(function(r) { if (!r.ok && r.status!==429) return null; return r.json(); })
        .then(function(data) {
          if (data && data.ready && data.source === source && validImage(data.image)) {
            ready[source] = data.image;delete retryAt[source];delete failed[source];armRetry();return data.image;
          }
          if (data && data.ready===false && !data.failed) {
            var delay=Number(data.retryAfterMs);
            queueRetry(source,Number.isFinite(delay)&&delay>0?delay:2000);
          }
          return null;
        }).catch(function(){return null;});
    }
    pending[source] = Promise.resolve().then(attempt).then(function(image){if(!image && !retryAt[source])failed[source]=Date.now();return image;}).finally(function(){delete pending[source];});
    return pending[source];
  }
  function imageOf(item) {
    var h = item.handle || '', p = item.properties || {};
    // Keep the ten existing photo/AI products' source behaviour unchanged.
    if (handles.indexOf(h) < 0) {
      var shape=shapeSource(p['_AI Image URL']), design=shapeDesign(item.product_title,h);
      return shape && design && shape[1]===design ? p['_AI Image URL'] : '';
    }
    return p[h.indexOf('custom-ai-') === 0 ? '_AI Image URL' : '_Your photo'] || '';
  }
  function prepareCart() {
    if (cartWork) { rerun = true; return cartWork; }
    cartWork = boundedFetch(root+'cart.js', {credentials:'same-origin',headers:{Accept:'application/json'}}, 3500)
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json();})
      .then(function(cart){
        var sources = [];
        (cart.items || []).forEach(function(item){var s=imageOf(item);if(validSource(s) && sources.indexOf(s)<0 && sources.length<50)sources.push(s);});
        return Promise.all(sources.map(prepare)).then(function(images){
          var rows=['v1'];sources.forEach(function(s,i){if(images[i])rows.push(s+'\t'+images[i]);});
          var table=rows.join('\n');
          if(table===lastTable || table.length>32768 || (table==='v1' && !lastTable))return;
          var attrs={};attrs[ATTR]=table;
          return boundedFetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({attributes:attrs})},3500)
            .then(function(r){if(r.ok)lastTable=table;});
        });
      }).catch(function(){})
      .finally(function(){cartWork=null;if(rerun){rerun=false;schedule();}});
    return cartWork;
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(prepareCart,350);}

  function cartShape(cart) {
    var groups = Object.create(null);
    (cart.items || []).forEach(function(item){
      var p=item.properties || {}, pairs=Object.keys(p).sort().filter(function(k){return k!==IMAGE && k!==SOURCE;}).map(function(k){return [k,p[k]];});
      var plan=item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      var key=JSON.stringify([item.handle,item.variant_id,plan && plan.id,pairs]);
      groups[key]=(groups[key] || 0)+item.quantity;
    });
    return JSON.stringify(Object.keys(groups).sort().map(function(k){return [k,groups[k]];}));
  }
  function readCart() {
    return boundedFetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}},3500)
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json();});
  }
  function syncCartMarkup() {
    var page=document.getElementById('PaintlyCartPage'), names=['cart-drawer','cart-icon-bubble'];
    // On the cart page, paintly-cart-page.js keeps the drawer in step itself. A drawer replaced from here looked to it
    // like a change made elsewhere, so its checkout check answered the press with "Your cart changed" and its own
    // drawer refresh wiped that message at once: the first press did nothing (14 Oct 2026). There, refresh the page
    // and the cart icon only.
    if(page && page.dataset.sectionId)names=[page.dataset.sectionId,'cart-icon-bubble'];
    return boundedFetch(root+'cart?sections='+names.map(encodeURIComponent).join(','),{credentials:'same-origin'},3500)
      .then(function(r){if(!r.ok)throw new Error('sections');return r.json();})
      .then(function(sections){
        names.forEach(function(name){
          if(!sections[name])return;
          var parsed=new DOMParser().parseFromString(sections[name],'text/html');
          var ids=name==='cart-drawer'?['CartDrawer']:name==='cart-icon-bubble'?['cart-icon-bubble']:['PaintlyCartPage'];
          ids.forEach(function(id){var old=document.getElementById(id),fresh=parsed.getElementById(id);if(old && fresh)old.innerHTML=fresh.innerHTML;});
        });
      }).catch(function(){});
  }
  function prepareOrder() {
    if(orderWork)return orderWork;
    orderChanged=false;
    var until=Date.now()+10000, changed=false, seen=Object.create(null), count=0, stopped=false;
    function idle(){
      if(!mutations)return Promise.resolve(true);
      if(Date.now()>=until)return Promise.resolve(false);
      return wait(50).then(idle);
    }
    function repair(cart) {
      if(stopped || mutations || Date.now()>=until || count>=30)return;
      var item=(cart.items || []).find(function(it){
        var source=imageOf(it),p=it.properties || {},image=ready[source];
        return it.key && it.quantity>0 && !it.selling_plan_allocation && validSource(source) && validImage(image) &&
          (p[SOURCE]!==source || p[IMAGE]!==image) && !seen[it.key+'|'+image];
      });
      if(!item)return;
      var source=imageOf(item),image=ready[source],p=Object.assign({},item.properties),version=revision,before=cartShape(cart);
      p[IMAGE]=image;p[SOURCE]=source;
      seen[item.key+'|'+image]=true;count++;
      changed=true;
      return boundedFetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:item.key,quantity:item.quantity,properties:p})},3500)
        .then(function(r){if(!r.ok)throw new Error('preview attachment');return r.json();})
        .then(function(next){
          if(revision!==version || mutations || cartShape(next)!==before){stopped=true;return;}
          return readCart().then(repair);
        });
    }
    orderWork=idle().then(function(ok){
      if(!ok)return;
      function freshCart(){clearTimeout(timer);rerun=false;failed=Object.create(null);return prepareCart();}
      var fresh=cartWork ? cartWork.then(freshCart) : freshCart();
      return Promise.race([fresh,wait(Math.max(0,until-Date.now()))]).then(function(){
        return idle().then(function(quiet){if(quiet && Date.now()<until)return readCart().then(repair);});
      });
    }).catch(function(){stopped=true;})
      .finally(function(){orderChanged=changed;return changed?syncCartMarkup():null;})
      .finally(function(){orderWork=null;});
    return orderWork;
  }

  function enrich(p) {
    var s=p['_AI Image URL'] || p['_Your photo'] || '';
    delete p[IMAGE];delete p[SOURCE];
    // Ajax add payloads contain variant IDs, not reliable product handles. Resolve
    // new Shape sources from the fresh cart (or the product form) before preparing.
    // This binds catalogue sources to their actual product title before preparing a preview.
    if(shapeSource(s))return Promise.resolve(p);
    return prepare(s).then(function(image){if(image){p[IMAGE]=image;p[SOURCE]=s;}return p;});
  }
  function enrichedBody(body) {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      var copy=body instanceof FormData ? new FormData() : new URLSearchParams();
      body.forEach(function(v,k){copy.append(k,v);});
      var p={};['_AI Image URL','_Your photo'].forEach(function(k){p[k]=copy.get('properties['+k+']');});
      return enrich(p).then(function(p){[IMAGE,SOURCE].forEach(function(k){copy.delete('properties['+k+']');if(p[k])copy.set('properties['+k+']',p[k]);});return copy;});
    }
    if(typeof body==='string'){
      var obj;try{obj=JSON.parse(body);}catch(_){return Promise.resolve(body);}
      var items=obj.items || [obj];
      return Promise.all(items.map(function(it){if(!it.properties)return null;return enrich(it.properties).then(function(p){it.properties=p;});})).then(function(){return JSON.stringify(obj);});
    }
    return Promise.resolve(body);
  }
  window.fetch = function(input, options) {
    var u;try{u=new URL(typeof input==='string'?input:input.url,location.href);}catch(_){return raw(input,options);}
    var method=String(options && options.method || input.method || 'GET').toUpperCase();
    if(u.origin!==location.origin || method!=='POST' || !/\/cart\/(add|change|update|clear)(?:\.js)?$/.test(u.pathname))return raw(input,options);
    mutations++;revision++;
    var add=/\/add(?:\.js)?$/.test(u.pathname);
    var work=add && options && options.body ? enrichedBody(options.body) : Promise.resolve(options && options.body);
    return work.then(function(body){var next=options?Object.assign({},options):undefined;if(next)next.body=body;return raw(input,next);})
      .then(function(response){if(response.ok)schedule();return response;})
      .finally(function(){mutations--;});
  };

  // Preview fields added for a Shape picture leave with it: the Shape block takes the picture out of the
  // form when the shopper picks another shape or a size of another shape (Claude review, 14 Oct 2026).
  function dropShapePreview(form){
    form.querySelectorAll('input[data-pk-shape-preview]').forEach(function(input){input.remove();});
  }
  function scanForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
      var field=form.querySelector('[name="properties[_AI Image URL]"]') || form.querySelector('[name="properties[_Your photo]"]');
      // Variant rendering can replace the photo form. Restore its existing, visibly attached
      // source before accelerated checkout as well as ordinary add-to-cart.
      if(!field){
        var scope=form.closest('.shopify-section'), id=form.getAttribute('id') || '';
        var photo=scope && scope.querySelector('#ppu[data-state="done"] #ppu-thumb');
        if(photo && /^product-form-/.test(id) && id.indexOf('installment')<0 && validSource(photo.getAttribute('src'))){
          field=document.createElement('input');field.type='hidden';field.name='properties[_Your photo]';
          field.setAttribute('data-ppu-prop','1');field.value=photo.getAttribute('src');form.appendChild(field);
        }
      }
      if(!field || !validSource(field.value)){dropShapePreview(form);return;}
      var s=field.value,shape=shapeSource(s);
      var match=location.pathname.match(/\/products\/([^/]+)\/?$/),h=match && match[1];
      if(shape && (field.name!=='properties[_AI Image URL]' || !h)){dropShapePreview(form);return;}
      function apply(image){
        if(!form.isConnected || field.value!==s || (shape && !location.pathname.endsWith('/products/'+h) && !location.pathname.endsWith('/products/'+h+'/')))return;
        [IMAGE,SOURCE].forEach(function(k){
          var input=form.querySelector('[name="properties['+k+']"]');
          if(!image){if(input)input.remove();return;}
          if(!input){input=document.createElement('input');input.type='hidden';input.name='properties['+k+']';form.appendChild(input);}
          if(shape)input.setAttribute('data-pk-shape-preview','');else input.removeAttribute('data-pk-shape-preview');
          input.value=k===IMAGE?image:s;
        });
      }
      function begin(){if(ready[s])apply(ready[s]);else prepare(s).then(apply);}
      if(shape){
        formProductTitle(h).then(function(title){
          if(!form.isConnected || field.value!==s)return;
          if(shapeDesign(title,h)!==shape[1]){dropShapePreview(form);return;}
          begin();
        });
      }else begin();
    });
  }
  function gate(e) {
    var button=e.type==='submit' ? e.submitter && e.submitter.name==='checkout' && e.submitter : e.target.closest && e.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if(!button || button===release)return;
    if(checkoutBusy){e.preventDefault();e.stopImmediatePropagation();return;}
    if(button.disabled)return;
    e.preventDefault();e.stopImmediatePropagation();checkoutBusy=true;
    button.disabled=true;button.setAttribute('aria-busy','true');
    var locked=Array.prototype.filter.call(document.querySelectorAll('cart-drawer,#PaintlyCartPage,form[action*="/cart/add"]'),function(el){return !el.inert;});
    locked.forEach(function(el){el.inert=true;});
    prepareOrder().finally(function(){
      locked.forEach(function(el){el.inert=false;});
      button.disabled=false;button.removeAttribute('aria-busy');checkoutBusy=false;
      // When a preview was just attached on the cart page, check out through the page's own button: the page re-reads
      // the cart first, and the drawer's form (not refreshed here) would post its older quantity list.
      var pageButton=orderChanged && document.getElementById('PaintlyCartPage') && document.getElementById('pcCheckout');
      var target=pageButton || (button.isConnected ? button : button.id && document.getElementById(button.id));
      if(!target || target.disabled)return;
      release=target;
      try{target.click();}finally{release=null;}
    });
  }
  window.PaintlyCheckoutArtwork={prepare:prepare,prepareCart:prepareCart,prepareOrder:prepareOrder};
  document.addEventListener('click',function(e){
    if(e.target.closest && e.target.closest('.shopify-payment-button,[data-shopify="payment-button"],shopify-accelerated-checkout'))scanForms();
    gate(e);
  },true);
  document.addEventListener('submit',gate,true);
  document.addEventListener('visibilitychange',function(){
    if(!document.hidden && retryOnVisible){retryOnVisible=false;armRetry();}
  });
  function start(){scanForms();schedule();setInterval(function(){if(!document.hidden)scanForms();},1200);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
